/**
 * Lectura de noticias contra el backend real (ASP.NET).
 *
 * SOLO LECTURA A PROPÓSITO: esta web no da de alta, edita, publica ni borra
 * noticias — eso se hace desde el CMS aparte (Web.CMS.React), que habla con el
 * mismo backend. No añadir aquí ninguna función de escritura (POST/PUT/DELETE)
 * sin hablarlo antes: es una decisión de arquitectura, no un olvido.
 *
 * Cada función hace tres cosas y en este orden: llama, valida la respuesta
 * contra el contrato (`parsers.ts`) y la traduce al modelo de la web
 * (`mappers.ts`). Fuera de este fichero nadie ve un DTO.
 *
 * Las rutas viven en `endpoints.ts`: aquí no hay ninguna cadena de URL.
 */

import type { News } from '../newsService';
import { NOTICIAS_ENDPOINTS } from './endpoints';
import { get } from './httpClient';
import { noticiaDesdeDto } from './mappers';
import { parseNoticia, parseNoticias } from './parsers';

/** Todas las publicadas. Es lo único que necesita el listado público. */
export async function listarNoticiasPublicadas(signal?: AbortSignal): Promise<News[]> {
  return parseNoticias(await get(NOTICIAS_ENDPOINTS.searchPublicadas, signal)).map(noticiaDesdeDto);
}

/**
 * Detalle por slug. No hay GET por id en el backend real.
 *
 * Hoy no la usa ningún componente (el detalle sigue navegando por id, ver
 * `newsService.getNewsById`), pero es la que hará falta el día que
 * `/noticias/:id` pase a `/noticias/:slug`.
 */
export async function obtenerNoticiaPorSlug(slug: string, signal?: AbortSignal): Promise<News> {
  return noticiaDesdeDto(parseNoticia(await get(NOTICIAS_ENDPOINTS.detailPorSlug(slug), signal)));
}
